import * as React from 'react'
import { Card, CardContent, IconButton, InputAdornment, TextField } from '@mui/material'
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material'

/**
 * Filters component for displaying search input and other options
 */
const Filters = ({ filters, setFilters }) => {
  const search = (keywords) => setFilters({ search: keywords })

  return (
    <Card variant="outlined" sx={{ my: 6, displayPrint: 'none' }}>
      <CardContent sx={{ py: 4, px: 3 }}>
        <TextField
          fullWidth
          placeholder="Search..."
          variant="outlined"
          size="small"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: filters.search && (
                <InputAdornment position="end">
                  <IconButton disableRipple edge="end" onClick={() => search('')}>
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          value={filters.search}
          onChange={(e) => search(e.target.value)}
        />
      </CardContent>
    </Card>
  )
}

export default Filters
